/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-undef */
import React, { useState, useContext, useEffect } from 'react';
import './styles.css';
import ChatIcon from '@material-ui/icons/Chat';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';
import { useLocation } from 'react-router-dom';
import io from 'socket.io-client';
import randomString from 'random-string';
import Loading from '../Loader/Loading';
import LiveStreamChat from './liveStreamChat';
import axios from 'axios';
const broadcastPeerId = randomString({ length: 8 }).toLowerCase();

// const socket = io.connect('http://localhost:7000/');

function LiveStreamPage()
{
	const [ streamKey, setStreamKey ] = useState('');
	const [ name, setName ] = useState('');
	const [ email, setEmail ] = useState('');
	const [ errorObj, setErrorObj ] = useState({});
	const [ broadcastOpen, setBroadcastOpen ] = useState(true);
	const [ slideInChat, setSlideInChat ] = useState(false);
	const [ slideInHandraise, setSlideInHandraise ] = useState(false);
	const [ chatBubbleCount, setChatBubbleCount ] = useState(0);
	const [ oldMessages, setOldMessages ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const [ broadcastUserDetails, setbroadcastUserDetails ] = useState({});

	const [ socket, setSocket ] = useState(null);

	// const [meetingId, setMeetingId] = useState('')

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;

	const meetingId = parameters.get('id');

	// setMeetingId(id)

	const validateEmail = (data) =>
	{
		// var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		const re = /^((([a-zA-Z]|[0-9])|([-]|[_]|[.])){1,})+[@](([a-zA-Z0-9])|([-]|[.])){2,40}[.]((([a-zA-Z0-9]){2,10})|(([a-zA-Z0-9]){2,4}[.]([a-zA-Z0-9]){2,4}))$/;

		return re.test(data);
	  };

	useEffect(() =>
	{
		const broadcastEmailId = localStorage.getItem('broadcastEmailId');
		const broadcastUsername = localStorage.getItem('broadcastUsername');
		const broadcastUserId = localStorage.getItem('broadcastUserId');

		if (broadcastEmailId !== null && broadcastUsername !== null && broadcastUserId === meetingId)
		{
			const streamingSocket = io.connect('https://invcwebinarapi.instavc.com/');

			setSocket(streamingSocket);

			streamingSocket.emit('room', meetingId, broadcastPeerId, broadcastUsername, 'streamingUser');
			setbroadcastUserDetails({
				...broadcastUserDetails,
				name      : broadcastUsername,
				email     : broadcastEmailId,
				userId    : broadcastPeerId,
				meetingId : meetingId
			});
		}
	}, []);

	const pastSocketMessages = async () =>
	{
		await axios.get(`${import.meta.env.VITE_InVcMainchatAPI}/getChat?meetingId=${meetingId}`)
			.then((res) =>
			{
				if (res.data)
				{
					setOldMessages(res.data.data);
					if (!slideInChat)
					{
						setChatBubbleCount(res.data.length);
					}
				}
			})
			.catch((err) =>
			{
				// console.log('err', err)
			});
	};

	useEffect(() =>
	{
		pastSocketMessages(meetingId);
	}, [ slideInChat ]);

	const submituser = () =>
	{

		const errorObject = {};

		if (!name || name === '')
		{
			errorObject['name'] = 'Please Enter Your Name';
			setErrorObj(errorObject);
		}
		else if (!email || email === '')
		{
			errorObject['email'] = 'Please Enter Your Email';
			setErrorObj(errorObject);
		}
		else if (!(validateEmail(email)))
		{
			errorObject['email'] = 'Please enter valid email';
			setErrorObj(errorObject);

		}
		else
		{
			setLoading(true);
			const body = {
				name      : name,
				email     : email,
				meetingId : meetingId
			};

			axios.post(`${import.meta.env.VITE_InVcMainchatAPI}/createbroadcastuser`, body)
				.then((res) =>
				{
					setLoading(false);
					// get api email in search params
					// create chat meeting Id, user id, mail, 
					const streamingSocket = io.connect('https://invcwebinarapi.instavc.com/');

					setSocket(streamingSocket);

					streamingSocket.emit('room', meetingId, broadcastPeerId, name, 'streamingUser');
					if (res.status && email !== '')
					{
						localStorage.setItem('broadcastUserId', meetingId);
						localStorage.setItem('broadcastEmailId', email);
						sessionStorage.setItem('uid',email)
						localStorage.setItem('broadcastUsername', name);
						setBroadcastOpen(false);
						axios.get(`${import.meta.env.VITE_InVcMainchatAPI}/getbroadcastusers?email=${email}`)
							.then((response) =>
							{
								// localStorage.clear('broadcastUserId');
								// localStorage.clear('broadcastEmailId');
								// localStorage.clear('broadcastUsername');
								if (res.status)
								{
									setbroadcastUserDetails({
										...broadcastUserDetails,
										name      : name,
										email     : email,
										userId    : broadcastPeerId,
										meetingId : meetingId
									});
								}
							})
							.catch((err) =>
							{
								console.log('err', err);
							});
						setName('');
						setEmail('');
						setErrorObj('');
					}

				})
				.catch((err) =>
				{

					console.log(err);
				});
		}
	};

	const handleChatSlide = async () =>
	{
		await pastSocketMessages(meetingId);
		setSlideInChat(true);
		setSlideInHandraise(false);
		setChatBubbleCount(0);
		// get api - meetingId
		// create Chat - 
	};

	const handleClose = () =>
	{
		setSlideInChat(false);
		pastSocketMessages(meetingId);
		setSlideInHandraise(false);
	};

	// const handleChatCount = () => {
	//     !slideInChat && setChatBubbleCount(chatBubbleCount + 1)

	// }
	return (
		<>
			<div className='flexCol liveStreamPage '>
				<div className='flexRow pdngSM lsHeader'>
					<img src='/images/invc_logo_header.png' alt='logo' />
				</div>
				<div className='flexMinWidthCol justifyCntr alignCntr'>
					<div className='flexRow pdngXS lsBody lsBody1'>
						<iframe width='100%' height='100%' title='liveStream' src={`https://newwebinar.invc.vc/play.html?name=${meetingId}&playOrder=hls`} allow='fullscreen; speaker' />
					</div>
				</div>
				<div className='flexRow justifyCntr alignCntr lsChat'>
					<Button color='primary' onClick={handleChatSlide}>
						<ChatIcon fontSize='large' />
					</Button>
				</div>
				{slideInChat && <LiveStreamChat openChat={slideInChat} handleCloseChat={handleClose} name={name} meetingid={meetingId} messages={oldMessages} broadcastUserDetails={broadcastUserDetails} socket={socket} />}
				{/* <LiveStreamChat chatL={chatL} setChatL={setChatL}/> */}
				{localStorage.getItem('broadcastUserId') !== meetingId &&
				<Dialog open={broadcastOpen}
					onClose={() => setBroadcastOpen(false)}
					aria-labelledby='form-dialog-title'
					disableBackdropClick
					disableEscapeKeyDown
				>
					<DialogTitle>User details</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							id='name'
							label='Name'
							type='text'
							onChange={(e) => setName(e.target.value)}
							fullWidth
							helperText={errorObj.name ? errorObj.name : ''}
							FormHelperTextProps={{
								error    : errorObj.name ? true : false,
								required : true
							}}
						/>
						<TextField
							margin='dense'
							id='email'
							label='Email'
							type='text'
							onChange={(e) => setEmail(e.target.value)}
							fullWidth
							helperText={errorObj.email ? errorObj.email : ''}
							FormHelperTextProps={{
								error    : errorObj.email ? true : false,
								required : true
							}}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={submituser} color='primary'>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
				}
			</div>
		</>
	);

}

export default LiveStreamPage;